import { jsx as _jsx } from "react/jsx-runtime";
import { FiltersButton } from "~/components/Filters/FiltersButton/FiltersButton";
import { useAppliedFiltersCount } from "~/hooks/filters/useAppliedFiltersCount";
export const BoardFiltersButton = (props)=>{
    const { filtersCount } = useAppliedFiltersCount();
    return /*#__PURE__*/ _jsx(FiltersButton, {
        filtersCount: filtersCount,
        ...props
    });
};
